import { useEffect } from "react";

// A tiny cross-screen bus so the header "Add new" menu can navigate to a
// section AND open that section's create form — even before it has mounted.
let pending = null;
let timer = null;

function clearPending() {
  pending = null;
  if (timer) { clearTimeout(timer); timer = null; }
}

export function triggerQuickAdd(section) {
  pending = section;
  if (timer) clearTimeout(timer);
  timer = setTimeout(clearPending, 4000); // don't fire stale opens later
  window.dispatchEvent(new CustomEvent("rca:navigate", { detail: { section } }));
  window.dispatchEvent(new CustomEvent("rca:quick-add", { detail: { section } }));
}

// Screens with a create form call this with a function that opens that form.
export function useQuickAdd(section, open) {
  useEffect(() => {
    if (pending === section) { clearPending(); open(); }
    const handler = (e) => { if (e.detail?.section === section) { clearPending(); open(); } };
    window.addEventListener("rca:quick-add", handler);
    return () => window.removeEventListener("rca:quick-add", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
